import React from 'react';
import $ from 'jquery';

import { slotGameMenuData } from '../shared/data/menu-data';
import Config from '../utils/config';
import { getCookie } from '../utils/cookie';
import { getTarget } from '../utils/BrowerCompatible';
import Label from '../utils/label';
import { NOpenKenoWindow, OpenGamePage } from '../thirdParty/NT3rdFun';
import config from '../utils/config';
import {getFullUrlPath} from '../utils/common';

class MenuItem extends React.Component {
	onItemClick = e => {
		e.preventDefault();
		this.props.onClick(this.props.id, this.props.openType, this.props.url, this.props.size);
		if (this.props.openType === 0) {
			$('.cMainMenun').removeClass('current');
			$(getTarget(e).parentElement).addClass('current');
		}
	};

	render() {
		const cansee = JSON.parse(Config.appConfig.getAccountMenu);
		const newTag = this.props.oriSize.indexOf('newtag') > -1 ? <span className="new">NEW</span> : '';
		let iconClass = '';
		let transName = this.props.transName;
		let homecss = '';
		if (this.props.name.toLowerCase() == 'tab01') {
			iconClass = 'icon-home';
			transName = '';
			homecss = ' home';
		}

		let Tab;

		if (this.props.openType == 2 && this.props.size == '2' && cansee.CanSeeSlotGameDropdown) {
			Tab = <SlotGameTabItem />;
		} else if (this.props.openType == 2 && this.props.size == '3') {
			Tab = <KenoTabItem />;
		} else {
			Tab = (
				<a
					href="javascript:void(0);"
					key={this.props.Key}
					id={this.props.id}
					name={this.props.name}
					onClick={this.onItemClick}
					className={iconClass}
				>
					{transName}
				</a>
			);
		}

		return <li className={'cMainMenun ' + this.props.classname + homecss}>{Tab}{newTag}</li>;
	}
}

function SlotGameTabItem() {
	const handleClick = event => {
		event.preventDefault();
	};

	const openProduct = vdid => event => {
		event.preventDefault();
		OpenGamePage(
			'slot-game', 
			'OneRNGCasino', 
			Config.appConfig.ActStatus, 
			null, 
			Label.lbl_PromptLoginDetail1, 
			Label.lbl_casino_alert, 
			{ vdid }
		);
	};

	return (
		<span>
			<a href="#" onClick={handleClick}>Slot Game</a>
			<ul className="main-menu-sub">
				{slotGameMenuData.map(item => (
					<li>
						<a 
							key={item.vdid}
							href="#" 
							onClick={openProduct(item.vdid)}
						>
							{Label[item.titleKey]}
						</a>
					</li>
				))}
			</ul>
		</span>
	);
}

class KenoTabItem extends React.Component {
	onClick(cust) {
		const lang = Config.appConfig.UserLang;
		const actStatus = Config.appConfig.ActStatus;
		let data = '';
		let msg = '';
		let flashMsg = '';
		if (cust === 'keno') {
			data = JSON.parse(Config.appConfig.Keno);
			msg = Label.lbl_KenoNoDeposit;
			flashMsg = Label.lbl_KenoFlashMsg;
		} else if (cust === 'kenolottery') {
			data = JSON.parse(Config.appConfig.KenoLottery);
			msg = Label.lbl_KenoLotteryNoDeposit;
			flashMsg = Label.lbl_KenoLotteryFlashMsg;
		} else if (cust === 'vgaming' || cust === 'vgamingmobi') {
			data = { 
				cust: 'vgaming',
				isEnabled: Config.appConfig[cust === 'vgamingmobi' ? 'CanSeeVGamingMobi' : 'CanSeeVGaming'],
				windowName: (cust === 'vgamingmobi' ? 'VGamingMobi' : 'VGaming')
			};
			msg = Label.lbl_PromptLoginDetail1;
			flashMsg = Label.lbl_casino_alert;
		} else if (cust === 'MaxGame') {
			data = {
				cust: 'maxgame',
				CanSeeMaxGame: Config.appConfig.CanSeeMaxGame
			};
			msg = Label.lbl_PromptLoginDetail1;
			flashMsg = Label.lbl_casino_alert;
		} else if (cust === 'lucky3d') {
			data = {
				cust: 'lucky3d',
				CanSeeLottoworld: Config.appConfig.CanSeeLottoworld
			};
			msg = Label.lbl_PromptLoginDetail1;
			flashMsg = Label.lbl_casino_alert;
		} 
		else {
			data = JSON.parse(Config.appConfig.TableGame);
			msg = Label.lbl_TableGameNoDeposit;
			flashMsg = Label.lbl_TableGameFlashMsg;
		}
		var RES_BlockPopMsg = Label.lbl_BlockPopMsg;
		NOpenKenoWindow(lang, data, msg, flashMsg, RES_BlockPopMsg, actStatus);
	}

	render() {
		const cansee = JSON.parse(Config.appConfig.getAccountMenu);
		return (
			<span>
				<a href="javascript:void(0);">{Label.lbl_TP_Keno}</a>
				{/*<span className="new">NEW</span>*/}
				<ul className="main-menu-sub">
					<li>
						<a href="javascript:void(0);" onClick={this.onClick.bind(this, 'keno')}>
							{Label.lbl_Keno}
						</a>
					</li>
					{cansee.CanSeeKenoLottery ? (
						<li>
							<a href="javascript:void(0);" onClick={this.onClick.bind(this, 'kenolottery')}>
								{Label.lbl_KenoLottery}
							</a>
							{/*<span className="new">NEW</span>*/}
						</li>
					) : null}
					{cansee.CanSeeTableGame ? (
						<li>
							<a href="javascript:void(0);" onClick={this.onClick.bind(this, 'TableGame')}>
								{Label.lbl_TableGame}
							</a>
							{/*<span className="new">NEW</span>*/}
						</li>
					) : null}
					{
						(!cansee.CanSeeVGaming || !cansee.EnableVGamingToKenoTab) ? null : [
							<li>
								<a href="javascript:void(0);" onClick={this.onClick.bind(this, 'vgaming')}>
									{Label.lbl_VGaming}
								</a>
							</li>,
							Config.appConfig.CanSeeVGamingMobi && 
							<li>
								<a href="javascript:void(0);" onClick={this.onClick.bind(this, 'vgamingmobi')}>
									{Label.lbl_VGamingMobi}
								</a>
							</li>
						]
					}
					{cansee.CanSeeMaxGame ? (
						<li>
							<a href="javascript:void(0);" onClick={this.onClick.bind(this, 'MaxGame')}>
							{Label.lbl_MaxGame}
							</a>
							<span className="new">NEW</span>
						</li>
					) : null}
					{cansee.CanSeeLottoworld ? (
						<li>
							<a href="javascript:void(0);" onClick={this.onClick.bind(this, 'lucky3d')}>
							{Label.lbl_Lottoworld}
							</a>
							<span className="new">NEW</span>
						</li>
					) : null}
				</ul>
			</span>
		);
	}
}
class MobileMenuItem extends React.Component {
	render() {
		return (
			<div className={"mobile-menu__item "+(this.props.itemClass)}>
				<i className={this.props.iconClass}/>
				<div className="mobile-menu__img">
				{
					!this.props.extraIcon ? null :
					<div className={this.props.extraIcon}/>
				}
				</div>
				<div className="mobile-menu__content">
					<div className="mobile-menu__info">
					{
						this.props.children
					}
					{
						!this.props.isNew ? null :
						<div className="mobile-menu-tag">
							<span className="mobile-menu-text">{Label.lbl_APPdownload_New}</span>
						</div>
					}
						<div className="mobile-menu-title">{this.props.title}</div>
						<div
							className="mobile-menu-btn"
							onClick = {this.props.onClick}
						>
							<span className="mobile-menu-text">{this.props.btnText}</span>
							<i className="icon-arrow-tip-right"/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default class MainMenu extends React.Component {
	mItemClick(id, openType, url, size) {
		this.props.selectTab(id, openType, url, size);
	}

	render() {
		// var self = this;
		const selectedTab = getCookie(setShowMainTab)
			? getCookie(setShowMainTab)
			: this.props.selectedTab;
		const mItems = this.props.menuItems.map(items => {
			const classname = selectedTab.toLowerCase() == items.TabName.toLowerCase() ? 'current' : '';
			var size = items.Size;
			if (items.OpenType == '2') {
				let cansee = JSON.parse(Config.appConfig.getAccountMenu);
				size = items.Size.replace('newtag', '');
				switch (size) {
					case '1':
						if (!cansee.CanSeeLiveCasino) {
							return;
						}
						break;
					case '2':
						if (!cansee.CanSeeCasino) {
							return;
						}
						break;
					case '3':
						if (!cansee.CanSeeKeno) {
							return;
						}
						break;
					case '4':
						if (!cansee.CanSeeAG) {
							return;
						}
						break;
					case '5':
						if (!cansee.CanSeeLottery) {
							return;
						}
						break;
					case '6':
						if (!cansee.CanSeeGold) {
							return;
						}
						break;
					case '7':
						if (!cansee.CanSeeExchange) {
							return;
						}
						break;
					case '8':
						if (!cansee.CanSeeTableGame) {
							return;
						}
						break;
					case '9':
						if (!cansee.CanSeeEsportsWeb) {
							return;
						}
						break;
					case '10':
						if (!cansee.CanSeeVGaming) {
							return;
						}
						break;
					case '11':
						if (!cansee.CanSeeVGamingMobi) {
							return;
						}
						break;
				}
			}
			return (
				<MenuItem
					key={items.TabName}
					id={items.TabName}
					name={items.TabName}
					transName={items.Translation}
					openType={items.OpenType}
					url={items.URL}
					oriSize={items.Size}
					size={size}
					classname={classname}
					onClick={(id, openType, url, size) => this.mItemClick(id, openType, url, size)}
				/>
			);
		});
		const mobileUrl = Config.appConfig.SiteID == 4200800 ? '//m.spondemo.com/' + window.location.search :
			'//smart.' + Config.appConfig.DomainName + '/' + window.location.search;
		const appDownloadUrl = Config.appConfig.DownloadAPPUrl;
		return (
			<nav className="main-menu">
				<ul>{mItems}
				{
					!config.appConfig.IsShowMobileTab ? null :
					<li className="cMainMenun mobile">
						<a href={!!appDownloadUrl? "#" : mobileUrl} key="mobileTab" name="mobileTab" className="icon-mobile"/>
					{
						!appDownloadUrl ? null :
						<div className="mobile-menu">
							<MobileMenuItem
								itemClass = "mobile-menu__item--app"
								iconClass = "icon-android"
								extraIcon = "mobile-menu-app-icon"
								isNew = {true}
								title = {Label.lbl_APPdownload_NativeApp}
								btnText = {Label.lbl_APPdownload_Download}
								onClick = {() => {window.location.href = appDownloadUrl}}
							>
								<div
									className="mobile-menu__qrcode"
									style={{
										backgroundImage: `url('${getFullUrlPath("AppDownload/GetAppQRCode")}')`
									}}
								/>
							</MobileMenuItem>
							<MobileMenuItem
								itemClass = "mobile-menu__item--web"
								iconClass = "icon-html5"
								title = {Label.lbl_APPdownload_MobileWeb}
								btnText = {Label.lbl_APPdownload_PlayNow}
								onClick = {() => {window.location.href = mobileUrl}}
							/>
						</div>
					}
					</li>
				}
				</ul>
			</nav>
		);
	}
}
